module.exports = __webpack_public_path__ + "c0a12d85dced85aa13f7b06a26668de5.svg";